import React from "react";

const rewards = [
  {
    name: "Mike Ross",
    reward: "1 Year Membership",
    status: "Earned",
    date: "05 Jul 2024",
  },
  {
    name: "Augustus Waters",
    reward: "1 Year Membership",
    status: "Earned",
    date: "05 Jul 2024",
  },
  {
    name: "Hazel Grace",
    reward: "1 Year Membership",
    status: "Pending",
    date: "06 Jul 2024",
  },
  {
    name: "Julia Anna",
    reward: "1 Year Membership",
    status: "Redeemed",
    date: "07 Jul 2024",
  },
];

const ReferralRewards = () => {
  return (
    <div className="rewards-page-wrappe">
      <div className="rewards-container">

        {/* Header */}
        <h2 className="rewards-title">Your Referral Rewards</h2>
        <p className="rewards-subtitle">
          Track rewards earned by inviting your friends
        </p>

        {/* Summary Cards */}
        <div className="rewards-summary">
          <div className="summary-card">
            <h3>4 Years</h3>
            <p>Total Earned</p>
          </div>
          <div className="summary-card">
            <h3>1</h3>
            <p>Pending</p>
          </div>
          <div className="summary-card">
            <h3>1</h3>
            <p>Redeemed</p>
          </div>
        </div>

        {/* Rewards List */}
        <div className="rewards-list">
          <h4>Reward History</h4>

          {rewards.map((item, index) => (
            <div className="reward-item" key={index}>
              <div className="reward-left">
                <div className="avatar">{item.name.charAt(0)}</div>
                <div>
                  <strong>{item.name}</strong>
                  <p>{item.reward}</p>
                </div>
              </div>

              <div className="reward-right">
                <span
                  className={`status ${item.status.toLowerCase()}`}
                >
                  {item.status}
                </span>
                <small>{item.date}</small>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default ReferralRewards;
